import { HeadlandIncreaseUnit } from "@omnia/shared/generated/enums"
import { FieldViewModel, ICrop, ICropping, IDataLayer, IDatalayerEditModel, IDataLayerType, IFieldFilter, ILayerViewModel, IOmniaService, ISeedRateMap, ISeedRateMapCalcParameters, ISeedRateMapCalcPeriod, ISeedRatePlan, IVariety, PlanValidationService } from "./exports"

export type { ISeedRateMap, ISeedRatePlan }

export enum BulkAdjustmentMode {
    Percentage = 1,
    Weight = 2
}

/**
 * Defaults are proprerties of a plan which are restored automatically when a new plan is created
 */
export interface NewPlanDefaults {

    useEstablishmentPct: boolean,

    headland: {
        width: number,
        increase: number,
        unit: HeadlandIncreaseUnit
    }

}

export interface ISeedRatePlanEditModel {

    plan: ISeedRatePlan,
    croppingIds: number[]

    bulkAdjustmentMode?: BulkAdjustmentMode
    bulkAdjustmentValue?: number

    sowingDate?: Date
    targetPopulation?: number

    recalculate: boolean

}

export interface ISeedRateServiceData {

    SupportedCrops: number[];
    Plans: ISeedRatePlan[];

}

export interface ISeedsService extends IOmniaService {

    readonly fields: FieldViewModel[]
    readonly cropping: FieldViewModel[]

    readonly planValidationService: PlanValidationService

    getHoldingCrops(): ICrop[]
    getHoldingVarieties(): IVariety[]

    getVariety(varietyId: number): IVariety

    state: IModuleState;

    filter: IFieldFilter

    selectedCropping: FieldViewModel

    getLayerTypes(): IDataLayerType[]
    getFieldLayers(fieldIds: number[], includeInactive?: boolean): ng.IPromise<IDataLayer[]>
    loadLayerZones(layers: IDataLayer[]): PromiseLike<IDataLayer[]>

    getLayerVisibility(datalayerId: number): boolean
    setLayerVisibility(datalayerId: number, visible: boolean): void

    getSupportedCrops(): number[];
    getSupportedSowingDates(cropId: number, varietyId: number): ng.IPromise<ISeedRateMapCalcPeriod[]>;

    getSeedLayerType(): IDataLayerType

    getNewPlanDefaults(): NewPlanDefaults

    getPlans(): ISeedRatePlan[];

    getPlanCropping(plan: ISeedRatePlan, includeAllCompatible: boolean): IPlanCropViewModel[];

    editPlan(plan: ISeedRatePlanEditModel): ng.IPromise<ISeedRatePlan>;
    deletePlan(planId: number): ng.IPromise<any>;

    drawSeedRatesMap(planId: number, mapId: number, map: IDatalayerEditModel): ng.IPromise<IDataLayer>;

    calculateSeedRatesMap(data: ISeedRateMapCalcParameters, refresh: boolean): ng.IPromise<IDataLayer>;

    getSeedQtyForPlan(plan: ISeedRatePlan): number
    getSeedsWeightForMap(plan: ISeedRatePlan, map: ISeedRateMap): number

}

export interface IModuleState {

    plan?: ISeedRatePlan
    expandedCropping?: number[]

}

export interface ISeedsService {

    readonly ready: boolean
    refresh(full?: boolean): ng.IPromise<any>

    getPlans(): ISeedRatePlan[]
    getPlanCropping(plan: ISeedRatePlan, includeAllCompatible: boolean): IPlanCropViewModel[]

    getSeedQtyForPlan(plan: ISeedRatePlan): number
    getSeedsWeightForMap(plan: ISeedRatePlan, map: ISeedRateMap): number

}

export interface IPlanCropViewModel {

    expanded: boolean
    selectable: boolean

    layer: ILayerViewModel

    readonly croppingVm: FieldViewModel
    readonly fieldVm: FieldViewModel
    readonly croppingId: number
    readonly cropping: ICropping

    plan: ISeedRatePlan
    readonly planCropping: ISeedRateMap
    readonly planId: number

}
